module.exports = __webpack_public_path__ + "img/create-account.b999544f.png";